import React, { useCallback, useEffect, useState } from "react";
import styles from "../Login/Login.module.css";
import NewHeader from "../NavBar/newHeader";
import { Card } from "react-bootstrap";
import OnboardingFooter from "../../component/Footer/OnboardingFooter";
import EmailVerification from "../../component/signup/emailVerification";
import CreateAccount from "../../component/signup/createAccount";
import LoginInput from "../../component/signup/loginInput";
import UpdatedPassword from "./UpdatedPassword";
import { ResendOtp, UpdatePassword, VerifyOtp } from "../../api";
import { useMyContext } from "../../myContext";
import { useNavigate } from "react-router";

function ForgotPassword({ onLogin }) {
  const [stepToShow, setStepToShow] = useState("emailOtp");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordInvalid, setPasswordInvalid] = useState(false);
  const [showError, setShowError] = useState("");
  const [curretAccountButtonDisabled, setCurrentAccountButtonDiabled] =
    useState(true);
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [confirmPasswordInvalid, setConfirmPasswordInvalid] = useState(false);
  const [password, setPassword] = useState("");
  const { username, setUsername, hashId, setHashId, partnerCode } = useMyContext();
  const [otperror, setOtpError] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (otp !== "") {
      checkOtp();
    }
  }, [otp]);

  const checkOtp = useCallback(() => {
    if (otp.length === 6) {
      otpVerification();
    }
  }, [otp]);

  const otpVerification = async () => {
    setErrorMessage("");
    setLoading(true);
    const body = {
      otp: otp,
      hashId: hashId,
    };
    try {
      VerifyOtp(body).then((resp) => {
        setLoading(false);
        if (resp && resp.status === 200) {
          setStepToShow("createAccount");
        } else {
          if (resp && resp.data && resp.data.message){
            setOtpError(resp.data.message);
            if(resp.data.message === "Number of attempts exceeded: Please try again after 3 mins"){
              setTimeout(() => {
                navigate("/login");
                setOtpError("");
              }, [3000])
            }
          }
          else if(resp && resp.message) setOtpError(resp.message);
          else setOtpError("something went wrong, please try again later.")
        }
      });
    } catch (error) {
      setLoading(false);
    }
  };

  const resendOtpVerification = async () => {
    setLoading(true);
    const body = {
      reason: "resend_otp",
      hashId: hashId,
      username: username,
      partnerCode: partnerCode
    };
    try {
      ResendOtp(body).then((resp) => {
        setLoading(false);
        const hashid = resp.data && resp.data.data ? resp.data.data.hashId : "";
        setHashId(hashid);
      });
    } catch (error) {
      setLoading(false);
    }
  };

  const passwordValidation = () => {
    setConfirmPasswordError("");
    let errorMessage = "";
    const testLength = /^(?=.{8,})/.test(password);
    const testAplha = /^(?=.*[a-z])/.test(password);
    const testUpperCase = /^(?=.*[A-Z])/.test(password);
    const testNumber = /^(?=.*[0-9])/.test(password);
    const testSpecialChar = /^(?=.*[!@#$%^&*])/.test(password);
    if (!testLength) {
      errorMessage = "Password must have 8 or more characters";
    } else if (!testAplha) {
      errorMessage = "Password needs to include atleast one lowercase alphabet";
    } else if (!testUpperCase) {
      errorMessage = "Password needs to include atleast one Uppercase alphabet";
    } else if (!testNumber) {
      errorMessage = "Password needs to include atleast number";
    } else if (!testSpecialChar) {
      errorMessage = "Password needs to include atleast one special symbol";
    } else {
      errorMessage = "";
      setPasswordInvalid("");
    }
    if (errorMessage !== "") {
      setPasswordInvalid(true);
    } else if (password !== confirmPassword) {
      errorMessage = "Password should be same as above";
      setConfirmPasswordInvalid(true);
    }
    if (password === confirmPassword) {
      setConfirmPasswordInvalid(false);
    }
    setConfirmPasswordError(errorMessage);
    return errorMessage;
  };

  const handleChange = (e) => {
    if (e.target.name === "email") {
      setUsername(e.target.value);
    } else if (e.target.name === "password") {
      setPassword(e.target.value);
    } else if (e.target.name === "confirm_password") {
      setConfirmPassword(e.target.value);
    }
    setPasswordInvalid(false);

  };

  const UpdatingPassword = async () => {
    setShowError("");
    setLoading(true);
    try {
      const body = {
        username: username,
        password: password,
        hashId: hashId,
        partnerCode: partnerCode
      };
      UpdatePassword(body).then((resp) => {
        setLoading(false);
        if (resp.status === 200) {
          setStepToShow("UpdatedPassword");
        } else {
          setShowError(resp.message);
        }
      });
    } catch (error) {
      setShowError("something went wrong, please try again later.");
      setLoading(false);
    }
  };

  const showComponent = () => {
    switch (stepToShow) {
      case "emailOtp":
        return (
          <EmailVerification
            username={username}
            setStepToShow={setStepToShow}
            loading={loading}
            otpVerification={otpVerification}
            setOtp={setOtp}
            otp={otp}
            otperror={otperror}
            resendOtpVerification={resendOtpVerification}
            errorMessage={errorMessage}
            Title={"Reset Your Password"}
            isEdit={false}
          />
        );
      case "createAccount":
        return (
          <CreateAccount
            username={username}
            setStepToShow={setStepToShow}
            loading={loading}
            navigate={navigate}
            handleChange={handleChange}
            setConfirmPassword={setConfirmPassword}
            confirmPassword={confirmPassword}
            curretAccountButtonDisabled={curretAccountButtonDisabled}
            passwordValidation={passwordValidation}
            createNewAccount={UpdatingPassword}
            confirmPasswordError={confirmPasswordError}
            passwordInvalid={passwordInvalid}
            confirmPasswordInvalid={confirmPasswordInvalid}
            showError={showError}
            Title={"Update your Password"}
            Subtitle={"Enter your new Password."}
            ButtonTitle={"Update Password"}
          />
        );
      case "UpdatedPassword":
        return <UpdatedPassword navigate={navigate} />;
      default:
        return <LoginInput handleChange={handleChange}/>;
    }
  };
  return (
    <>
      <NewHeader show={false} />
      <div className={styles.cardDiv}>
        <Card className={styles.cardSignUp}>
          <Card.Body className={styles.cardBodySignup}>
            {showComponent()}
          </Card.Body>
        </Card>
      </div>
      <OnboardingFooter />
    </>
  );
}

export default ForgotPassword;
